<template>
  <v-table>
    <thead>
      <tr>
        <th class="text-left">ユーザID</th>
        <th class="text-left">名前</th>
        <th class="text-left">メールアドレス</th>
        <th class="text-left">パスワード</th>
        <th class="text-right">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in users" :key="item.id">
        <template v-if="!(editing === index)">
          <td>{{ item.user_id }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.mail }}</td>
          <td>{{ item.password }}</td>
          <td class="text-right">
            <v-icon @click="editRow(index)">mdi-pencil</v-icon>
            <v-icon @click="deleteConfirm(index, item.user_id)">mdi-delete</v-icon>
          </td>
          
        </template>
        <template v-else>
          <td><v-text-field type="text" v-model="item.user_id"/></td>
          <td><v-text-field type="text" v-model="item.name"/></td>
          <td><v-text-field type="text" v-model="item.mail"/></td>
          <td><v-text-field type="text" v-model="item.password"/></td>
          <td class="text-right">
              <v-icon @click="updateRow(index)">mdi-check</v-icon>
              <v-icon @click="editCancelRow(index)">mdi-cancel</v-icon>
          </td>
        </template>
      </tr>
    </tbody>
  </v-table>
  <v-row class="justify-space-between">
    <v-col></v-col>
    <v-col v-if="!addEdit"  class="text-right">
      <v-btn icon color="primary" @click="addRow()"><v-icon>mdi-plus</v-icon></v-btn>
    </v-col>
  </v-row>

  <!-- 削除確認ダイアログを追加 -->
  <v-dialog v-model="deleteDialog" persistent max-width="290">
    <v-card>
      <v-card-title class="headline">削除確認</v-card-title>
      <v-card-text>user_id:{{ deleteID }}を削除してもよろしいですか？</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="deleteDialog = false">キャンセル</v-btn>
        <v-btn color="green darken-1" text @click="deleteRow(deleteIndex)">削除</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import axios from 'axios'

  export default {
    data () {
      return {
        users: [
          {
            recode_id: 1,
            user_id: 'fy',
            name: 'Frozen Yogurt',
            password: 'pass',
            mail: 159,
          },
        ],
        editing: null,
        addEdit: false,
        deleteDialog: false,	// 追加：初期値は非表示
        deleteID: null,			// 追加：削除Itemのid
        deleteIndex: null,
      }
    },
    created: function () {
      this.getData();
    },
    methods: {
      // データ取得
      getData() {
        axios.get(process.env.VUE_APP_API_URL + '/api/users')
        .then(response => {
          console.log(response.data); // mockData
          console.log(response.status); // 200
          this.users = response.data.users;
        })
      },
      // 編集
      editRow(index) {
        console.log(index);
        this.editing = index;
      },
      // 編集キャンセル
      editCancelRow(index) {
        console.log(index);
        this.editing = null;
        if(this.addEdit) {
          this.addEdit = false;
          this.users.pop();
        }
      },
      // 更新
      updateRow(index) {
        console.log(this.users[index]);
        this.editing = null;
        var method = 'PUT';
        var url = process.env.VUE_APP_API_URL + '/api/users/' + this.users[index].recode_id;
        // 追加の場合
        if (this.addEdit) {
          method = 'POST';
          url = process.env.VUE_APP_API_URL + '/api/users';
          this.addEdit = false;
        }
        axios({
          method: method,
          url: url,
          data: JSON.stringify(this.users[index]), 
          headers:{'Content-Type': 'application/json; charset=utf-8'}
        })
        .then(response => {
          console.log(response.data); // mockData
          console.log(response.status); // 200
          this.getData();
        })
      },
      // 追加
      addRow() {
        this.users.push({
          id: null, name: '', age: null
        });
        this.addEdit = true;
        this.editing = this.users.length - 1;
      },
      // 削除確認ダイアログ表示
      deleteConfirm(index, id) {
        this.deleteDialog = true;
        this.deleteIndex = index;
        this.deleteID = id;
      },
      // 削除
      deleteRow(index) {
        console.log(index);
        axios({
            method: 'DELETE',
            url: process.env.VUE_APP_API_URL + '/api/users/' + this.users[index].recode_id,
            headers:{'Content-Type': 'application/json; charset=utf-8'}
          })
          .then(response => {
            console.log(response.data); // mockData
            console.log(response.status); // 200
            this.deleteDialog = false;
            this.getData();
          })
      },
      // 必須
      isInValidRequired(value) {
        if (value) {
          return value.length < 1;
        }
      },
    }
  }
</script>